
import { useState, useEffect } from "react";

export const useHiddenRoutines = (planId: string | undefined) => {
  const [hiddenRoutines, setHiddenRoutines] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Cargar rutinas ocultas del localStorage al iniciar
  useEffect(() => {
    if (!planId) {
      setIsLoading(false);
      return;
    }
    
    setIsLoading(true);
    
    const key = `hidden-routines-${planId}`;
    const storedHiddenRoutines = localStorage.getItem(key);
    
    if (storedHiddenRoutines) {
      try {
        const parsedRoutines = JSON.parse(storedHiddenRoutines);
        setHiddenRoutines(Array.isArray(parsedRoutines) ? parsedRoutines : []);
      } catch (error) {
        console.error("Error parsing hidden routines from localStorage:", error);
        setHiddenRoutines([]);
      }
    }
    
    setIsLoading(false);
  }, [planId]);

  // Guardar en localStorage cada vez que cambia el estado
  useEffect(() => {
    if (!planId || hiddenRoutines.length === 0) return;
    
    const key = `hidden-routines-${planId}`;
    localStorage.setItem(key, JSON.stringify(hiddenRoutines));
    console.log("Saved hidden routines to localStorage:", hiddenRoutines);
  }, [hiddenRoutines, planId]);

  const hideRoutine = (routineId: string) => {
    setHiddenRoutines(prev => {
      if (prev.includes(routineId)) return prev;
      return [...prev, routineId];
    });
  };

  const showRoutine = (routineId: string) => {
    setHiddenRoutines(prev => prev.filter(id => id !== routineId));
  };

  const toggleRoutineVisibility = (routineId: string) => {
    if (hiddenRoutines.includes(routineId)) {
      showRoutine(routineId);
    } else {
      hideRoutine(routineId);
    }
  };

  return {
    hiddenRoutines,
    hideRoutine,
    showRoutine,
    toggleRoutineVisibility,
    isLoading
  };
};
